export enum FeatureFlag {
  CfarShowPaymentMethodDisclaimer = 'cfar-show-payment-method-disclaimer',
  CfarUseExerciseRedesign = 'cfar-use-exercise-redesign',
}
